import { useCallback, useState } from 'react';
import { useRouter } from 'next/navigation';
import getCurrentSortParams from './helper/getCurrentSortParams';
import sendEventToUmami from '@/client/helpers/trackEvent/sendEventToUmami';
import updateQueryParam from '@/client/utils/updateQueryParam/updateQueryParam';
import debounce from '@/shared/utils/debounce/debounce';

const useSortFilter = (sortParams: string | undefined) => {
  const paramsData = getCurrentSortParams(sortParams);
  const router = useRouter();
  const [sort, setSort] = useState(paramsData);

  const updateURL = debounce((selected: SelectedSort) => {
    setSort(selected);
    const newPathQuery = updateQueryParam(
      location.href,
      'sort',
      `${selected.name}:${selected.value}`,
    );
    router.push(newPathQuery);
  }, 100);

  const handleSelect = useCallback(
    (name: SelectedSort['name']) => {
      sendEventToUmami(
        {
          'sort-base': name,
        },
        'changeSortBy',
      );

      if (name === sort.name) {
        return updateURL({ name, value: sort.value === 1 ? -1 : 1 });
      }
      return updateURL({ name, value: name === 'name' ? 1 : -1 });
    },
    [sort.name, sort.value, updateURL],
  );

  return { sort, handleSelect };
};

export default useSortFilter;
